import { render, staticRenderFns } from "./communications.vue?vue&type=template&id=0c7202ab&"
import script from "./communications.vue?vue&type=script&lang=js&"
export * from "./communications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports